import styled, { css } from 'styled-components';

export const MenuBar = styled.div<{ $isPrePTO: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;

  @media screen and (min-width: ${({ theme, $isPrePTO }) =>
      $isPrePTO ? theme.breakpoints.small : theme.breakpoints.medium}) {
    position: unset;
    min-width: 204px;
    max-width: 232px;
    height: unset;
    z-index: unset;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}) {
    min-width: ${({ $isPrePTO }) => ($isPrePTO ? '320px' : '220px')};
  }
`;

export const LayoutContent = styled.div<{ $isAuthScreen?: boolean; $isPrePTO?: boolean }>`
  ${({ theme, $isAuthScreen, $isPrePTO }) => `
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 20px 16px 0;
    background: ${
      $isAuthScreen ? theme.colors.backgroundSecondaryGrey05 : theme.colors.cardElevationLowWhite
    };

    @media screen and (min-width: ${theme.breakpoints.small}) {
      padding: 26px 24px 0;
    }

    @media screen and (min-width: ${$isPrePTO ? theme.breakpoints.small : theme.breakpoints.medium}) {
      padding: 34px 32px 0;
      border-radius: 24px 0 0 24px;
      box-shadow: ${theme.elevations.mid};
    }

    @media screen and (min-width: ${theme.breakpoints.large}) {
      padding: 44px 48px ${$isAuthScreen ? '24px' : '0'};
    }
  `}
`;

export const LayoutWrapper = styled.div<{ $isPrePTO: boolean }>`
  ${({ theme, $isPrePTO }) => css`
    display: flex;
    min-height: 100vh;
    height: 100%;
    padding: 0;
    max-width: 1920px;
    margin-right: auto;
    @media (width < ${theme.breakpoints.small}) {
      flex-direction: column;
    }
    @media (${theme.breakpoints.small} <= width < ${theme.breakpoints.medium}) {
      flex-direction: ${$isPrePTO ? 'row' : 'column'};
    }
  `}
`;

export const LayoutContentInner = styled.div<{ $isAuthScreen?: boolean }>`
  max-width: ${({ $isAuthScreen }) => ($isAuthScreen ? 'unset' : '1124px')};
`;
